module.exports = __webpack_public_path__ + "img/gme-ftd-percent-trade-volume-30d-avg.a1415168.jpg";